<template>
  <div>
    <Head :title="moneyReturn.data.id.toString()"/>


    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/shofer-mbledhes/mjetet">Kthimet e mjeteve</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ moneyReturn.data.id }}
    </h1>

    <danger-flash-message v-if="moneyReturn.data.description"  :message="`Koment nga shitësi: ${moneyReturn.data.description}`"></danger-flash-message>


    <div class=" bg-white rounded-md shadow overflow-hidden">
      <div class="flex flex-wrap items-center space-y-4 lg:space-y-0 justify-between -mr-6 p-5">

        <div class="flex flex-wrap mb-4">
          <label class="font-bold">Statusi Aktual: &nbsp;</label>
          <p><span class="mx-0.5 px-2 py-1 rounded-md text-white" :class="statusColor"
          >{{ moneyReturn.data.status }}</span></p>
        </div>


        <div class="flex flex-wrap lg:space-y-0">

          <div class="flex flex-wrap items-center">
            <select-input v-model="form.status_id" :error="form.errors.status_id" class="pb-8 pr-6 w-full"
                          label="Ndrysho statusin"
            >
              <option v-for="status in statuses" :key="status.id" :value="status.id">{{ status.name }}</option>
            </select-input>
            <Teleport to="body">
              <!-- use the modal component, pass in the prop -->
              <modal :show="showModal" @close="showModal = false">
                <template #header>
                  <h3>Duhet të jipet një koment.</h3>
                </template>

                <template #body>

                  <div class="flex flex-wrap">
                    <textarea-input :required="true" v-model="form.status_comment" :error="form.errors.status_comment"
                                    class="w-full pb-4" label="Komenti (Arsyeja)"
                    />
                    <file-input v-model="form.status_document" :error="form.errors.status_document" class="w-full pb-4"
                                type="file" accept="image/*" label="Dëshmi (nëse ka)"
                    />
                  </div>
                </template>

                <template #footer>
                  <div class="flex flex-wrap">
                    <loading-button class="btn-indigo bg-red-500"
                                    @click="showModal = false"
                    >Anulo
                    </loading-button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="button"
                                    @click="updateStatus(form.status_id);"
                    >Ndrysho statusin
                    </loading-button>
                  </div>
                </template>
              </modal>
            </Teleport>
          </div>
        </div>

      </div>
    </div>


    <div class="flex flex-wrap  space-y-4 lg:flex-nowrap lg:space-x-4 lg:space-y-0 mb-8 mt-5">
      <div class=" bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">

        <div class="flex flex-wrap lg:flex-nowrap mb-6 items-center justify-between">

          <div class="flex flex-wrap items-end space-y-4 lg:space-y-0 -mb-8 p-8">
<!--            <Link  v-if="!order.data.is_change"  class="mr-1" :href="`${order.data.id}/edit`" ><icon name="edit" class="mr-2 w-4 h-4"></icon></Link>-->
            <dropdown class="mr-2 w-4 h-4" placement="bottom-end">
              <template #default>
                <icon name="print" class="mr-2 w-4 h-4"></icon>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.money-return.pdf',{moneyReturn: moneyReturn.data.id})" target="_blank">Printo PDF</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.money-return.sticker.8x5',{moneyReturn: moneyReturn.data.id})" target="_blank">Printo Stiker 8x5cm</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.money-return.sticker.10x7',{moneyReturn: moneyReturn.data.id})" target="_blank">Printo Stiker 10x7cm</a>
                </div>
              </template>
            </dropdown>
          </div>


        </div>
        <hr>


        <div class="flex flex-wrap -mb-8 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Dërgesa (ID)</label>
            <p>{{moneyReturn.data.order_id}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Dërgesa për kthim (ID)</label>
            <p>{{ moneyReturn.data.order_change_id}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Pika marrëse</label>
            <p>{{ moneyReturn.data.paid_by_seller ? moneyReturn.data.location : 'Mjetet te mirren nga posta' }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Biznesi</label>
            <p>{{ moneyReturn.data.business }}</p>
          </div>


          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Shuma e mjeteve</label>
            <p>{{ moneyReturn.data.amount }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Çmimi i postes</label>
            <p>{{ moneyReturn.data.shipping_price }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-2/4">
            <label class="font-bold">Përshkrimi</label>
            <p>{{ moneyReturn.data.description }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Data e regjistrimit</label>
            <p>{{moneyReturn.data.hr_created_at}}</p>
          </div>
        </div>

        <hr>
        <div class="flex flex-wrap -mb-8 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Emri i klientit</label>
            <p>{{moneyReturn.data.client}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Telefoni</label>
            <p>{{ moneyReturn.data.phone}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Qyteti</label>
            <p>{{ moneyReturn.data.city }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Adresa</label>
            <p>{{ moneyReturn.data.address }}</p>
          </div>
        </div>


      </div>

      <div class=" bg-white rounded-md shadow overflow-hidden p-5  w-full lg:w-1/2">
        <h1 class="mb-3 text-xl font-bold">Gjurmimi i kthimit të mjeteve</h1>

        <div class="flex flex-wrap -mb-8 p-8">
          <order-change-status-timeline :items="moneyReturnStatusLogs.data"></order-change-status-timeline>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import {computed} from 'vue'
import SearchFilter from '@/Shared/SearchFilter'
import Icon from '@/Shared/Icon'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileOutput from '@/Shared/FileOutput'
import Modal from '@/Shared/Modal'
import FileInput from '@/Shared/FileInput'
import OrderChangeStatusTimeline from '@/Shared/OrderChangeStatusTimeline'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import Dropdown from '@/Shared/Dropdown'

export default {
  components: {
    OrderChangeStatusTimeline,
    Icon,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    SearchFilter,
    TrashedMessage,
    FileOutput,
    Modal,
    FileInput,
    DangerFlashMessage,
    Dropdown
  },
  layout: Layout,
  props: {
    moneyReturn: Object,
    moneyReturnStatusLogs: Object,
    statuses: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        status_id: this.moneyReturn.data.status_id,
        status_comment: null,
        status_document: null,
      }),
      statusSuccess: this.moneyReturn.data.status_id === 5,
      statusCancellation: this.moneyReturn.data.status_id === 6,
      showModal: false,
    }
  },
  methods: {
    success() {
      if (confirm('Kjo dërgesë është kthim i mjeteve. Ju lutem konfirmoni se keni marrë pakon e cila duhet të kthehet tek shitësi.')) {
        this.updateStatus()
      }
    },
    updateStatus(newValue) {
      let self = this

      this.form.post(route('collecting-driver.money-returns.update.status', {moneyReturn: this.moneyReturn.data.id}), {
        onError: function (errors) {
          if (!errors.status_comment && !errors.status_comment)
            self.showModal = false
        },
        onSuccess: function () {
          self.showModal = false
          self.statusSuccess = newValue === 5
          self.statusCancellation = newValue === 6
        },
      })

      this.form.status_comment = null
      this.form.status_document = null


    },
  },
  watch: {
    'form.status_id'(newValue) {
      if (newValue === 6) {
        this.showModal = true
      }else if(newValue === 5){
        this.success()
      }
      else {
        this.updateStatus(newValue)
      }
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
  computed: {
    statusColor() {
      let color = 'bg-indigo-500'
      if (this.moneyReturn.data.status_id === 1)
        color = 'bg-yellow-500'

      if (this.moneyReturn.data.status_id === 3)
        color = 'bg-orange-500'

      if (this.moneyReturn.data.status_id === 4)
        color = 'bg-indigo-900'

      if (this.moneyReturn.data.status_id === 5)
        color = 'bg-green-500'

      if (this.moneyReturn.data.status_id === 6)
        color = 'bg-red-500'


      return color
    },
  },
}
</script>

<style>
</style>
